import { render, staticRenderFns } from "./GenderTabs.vue?vue&type=template&id=9eb117da&scoped=true&"
import script from "./GenderTabs.vue?vue&type=script&lang=js&"
export * from "./GenderTabs.vue?vue&type=script&lang=js&"
import style0 from "./GenderTabs.vue?vue&type=style&index=0&id=9eb117da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb117da",
  null
  
)

export default component.exports